<template>
    <customer-layout>
        <div class="min-h-screen pb-4 overflow-x-hidden bg-gray-800">
            <div class="relative flex flex-col items-center content-between">
                <!-- <div class="relative w-full">
                    <SlideSlider :slides="slides"></SlideSlider>
                </div> -->
                <!-- osm upcoming events -->
                <!-- <div class="w-full px-4 py-8 mb-8 text-white bg-gray-900">
                    <div class="mx-auto md:max-w-screen-lg">
                        <h1 class="mb-4 text-2xl text-white">
                            {{ $t("Prossimi") }}
                            <span class="text-pink-600">{{
                                $t("Eventi")
                            }}</span>
                        </h1>
                        <carousel
                            :perPage="1"
                            :autoplay="true"
                            :autoplay-timeout="3000"
                            :loop="true"
                            :paginationEnabled="true"
                        >
                            <slide
                                v-for="(event, index) in upcoming_events"
                                :key="index"
                            >
                                <div class="relative slide-content">
                        
                                    <img
                                        :src="`https://eventiosm.it${event.cover}`"
                                        class="w-full h-96 object-cover"
                                    />

            
                                    <div
                                        class="absolute inset-0 flex items-center justify-center"
                                    >
                      
                                        <div
                                            class="absolute inset-0 bg-black opacity-50"
                                        ></div>

                                        <div
                                            class="relative flex flex-col items-center text-center p-4 z-10"
                                        >
                                 
                                            <h2
                                                class="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-600 via-pink-700 to-gray-200 break-words whitespace-normal max-w-3/4"
                                            >
                                                {{ event.title }}
                                            </h2>
                                   
                                            <div
                                                class="text-2xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-yellow-600 via-pink-700 to-gray-200 mt-4"
                                            >
                                                <h2>
                                                    {{
                                                        event.date
                                                            | moment(
                                                                "DD-MM-YYYY"
                                                            )
                                                    }}
                                                </h2>
                                                <h2>{{ event.place }}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </slide>
                        </carousel>
                    </div>
                </div> -->

                <div class="mx-auto md:max-w-screen-xl">
                    <div class="flex flex-wrap w-full pb-16">
                        <div class="w-6/12 p-2 md:w-4/12">
                            <inertia-link
                                :href="route('qrcode.intro')"
                                class="pb-2 mb-2 bg-white rounded-lg shadow-md"
                            >
                                <div
                                    class="flex flex-col justify-center py-4 bg-gray-900 rounded-t-lg min-h-img"
                                >
                                    <div class="w-full mx-auto my-2">
                                        <!-- <div class="w-2/12">
                                            <span class="inline-block text-lg text-center text-blue-300 border border-blue-300 border-solid rounded-full w-7 h-7">1</span>
                                        </div> -->
                                        <div
                                            class="mx-auto w-36 cust-text-center"
                                        >
                                            <img
                                                src="/img/icon-qrcode.svg"
                                                alt="gem"
                                                class="mx-auto"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box"
                                >
                                    <h4 class="mb-1 font-bold">
                                        {{ $t("QR Code") }}
                                    </h4>
                                    <p class="text-sm font-extralight">
                                        {{
                                            $t(
                                                "Upload your Questionnaire through the QR Code and get your program"
                                            )
                                        }}
                                    </p>
                                </div>
                            </inertia-link>
                        </div>
                        <div class="w-6/12 p-2 md:w-4/12">
                            <inertia-link
                                :href="route('users.show', user.id)"
                                class="pb-2 mb-2 bg-white rounded-lg shadow-md"
                            >
                                <div
                                    class="flex flex-col justify-center py-4 bg-gray-900 rounded-t-lg min-h-img"
                                >
                                    <div
                                        class="flex content-between justify-between w-full my-2"
                                    >
                                        <!-- <div class="w-2/12">
                                            <span class="inline-block text-lg text-center text-blue-300 border border-blue-300 border-solid rounded-full w-7 h-7">2</span>
                                        </div> -->
                                        <div
                                            class="mx-auto w-36 cust-text-center"
                                        >
                                            <img
                                                src="/img/icon-heart.svg"
                                                alt="gem"
                                                class="mx-auto"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box"
                                >
                                    <h4 class="mb-1 font-bold">
                                        {{ $t("Delivery Results") }}
                                    </h4>
                                    <p class="text-sm font-extralight">
                                        {{
                                            $t(
                                                "Analyze the results of your Questionnaire"
                                            )
                                        }}
                                    </p>
                                </div>
                            </inertia-link>
                        </div>

                        <!--Programmi di miglioramento-->
                        <div class="w-6/12 p-2 md:w-4/12">
                            <inertia-link
                                :href="route('curricula')"
                                class="pb-2 mb-2 bg-white rounded-lg shadow-md"
                            >
                                <div
                                    class="flex flex-col justify-center py-6 bg-gray-900 rounded-t-lg min-h-img"
                                >
                                    <div
                                        class="flex content-between justify-between w-full my-2"
                                    >
                                        <!-- <div class="w-2/12 mx-auto my-2">
                                            <span class="inline-block text-lg font-bold text-center text-blue-300 border border-blue-300 border-solid rounded-full w-7 h-7">3</span>
                                        </div> -->
                                        <div
                                            class="w-full mx-auto cust-text-center"
                                        >
                                            <img
                                                src="/img/icon-barchart.svg"
                                                alt="gem"
                                                class="mx-auto"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box"
                                >
                                    <h4 class="mb-1 font-bold">
                                        {{ $t("Improvement Programs") }}
                                    </h4>
                                    <p class="text-sm font-extralight">
                                        {{
                                            $t(
                                                "Get skilled and win more OSM Coins"
                                            )
                                        }}
                                    </p>
                                </div>
                            </inertia-link>
                        </div>

                        <!--Audiolibri-->
                        <div class="w-6/12 p-2 md:w-4/12">
                            <inertia-link
                                :href="route('audiobooks')"
                                class="pb-2 mb-2 bg-white rounded-lg shadow-md"
                            >
                                <div
                                    class="flex flex-col justify-center bg-gray-900 rounded-t-lg min-h-img py-7 video-bkg"
                                >
                                    <div
                                        class="flex content-center justify-center w-full my-2"
                                    >
                                        <!-- <div class="w-2/12 mx-auto my-2">
                                            <span class="inline-block text-lg font-bold text-center text-blue-300 border border-blue-300 border-solid rounded-full w-7 h-7">5</span>
                                        </div> -->
                                        <div
                                            class="w-full mx-auto cust-text-center"
                                        >
                                            <img
                                                src="/img/icon-play.svg"
                                                alt="gem"
                                                class="h-16 mx-auto"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box"
                                >
                                    <h4 class="mb-1 font-bold">
                                        {{ $t("Audiobooks") }}
                                    </h4>
                                    <p class="text-xs font-extralight">
                                        {{
                                            $t(
                                                "Listen to audiobooks and earn more OSM Coins."
                                            )
                                        }}
                                    </p>
                                </div>
                            </inertia-link>
                        </div>

                        <!--Lavoro-->
                        <div class="w-6/12 p-2 md:w-4/12">
                            <inertia-link
                                :href="route('jobs.show')"
                                class="pb-2 mb-2 bg-white rounded-lg shadow-md"
                            >
                                <div
                                    class="flex flex-col justify-center bg-gray-900 rounded-t-lg min-h-img"
                                >
                                    <div
                                        class="flex content-between justify-between w-full"
                                    >
                                        <!-- <div class="w-2/12 mx-auto my-2">
                                            <span class="inline-block text-lg font-bold text-center text-blue-300 border border-blue-300 border-solid rounded-full w-7 h-7">6</span>
                                        </div> -->
                                        <div
                                            class="w-full mx-auto cust-text-center"
                                        >
                                            <img
                                                src="/img/job-role.png"
                                                alt="gem"
                                                class="w-full"
                                                style="
                                                    max-width: 160px;
                                                    margin: 0 auto;
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box"
                                >
                                    <h4 class="mb-1 font-bold">
                                        {{
                                            $t(
                                                "Find out what job you are best suited for"
                                            )
                                        }}
                                    </h4>
                                    <p class="text-xs font-extralight">
                                        {{
                                            $t(
                                                "Discover the business area where it is easier for your potential to explode"
                                            )
                                        }}
                                    </p>
                                </div>
                            </inertia-link>
                        </div>

                        <!--Aprire una nuova azienda-->
                        <div class="w-6/12 p-2 md:w-4/12">
                            <inertia-link
                                :href="route('program.startup')"
                                class="pb-2 bg-white rounded-lg shadow-md"
                            >
                                <div class="bg-white rounded-lg shadow-md">
                                    <div
                                        class="flex flex-col justify-center bg-gray-900 rounded-t-lg min-h-img"
                                    >
                                        <div
                                            class="flex content-between justify-between w-full"
                                        >
                                            <div
                                                class="w-full mx-auto cust-text-center"
                                            >
                                                <img
                                                    src="/img/startup.png"
                                                    alt="startup"
                                                    class="w-full"
                                                    style="
                                                        max-width: 100px;
                                                        margin: 0 auto;
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box"
                                    >
                                        <h4 class="mb-1 font-bold">
                                            {{ $t("Startup") }}
                                        </h4>
                                        <p class="text-xs font-extralight">
                                            {{
                                                $t(
                                                    "Some information that will help you understand the actions you need to take to open a new company."
                                                )
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </inertia-link>
                        </div>

                        <!--Ottieni più OSM Coin-->
                        <div class="w-6/12 p-2 md:w-4/12">
                            <inertia-link
                                :href="route('howto')"
                                class="pb-2 mb-2 bg-white rounded-lg shadow-md"
                            >
                                <div
                                    class="flex flex-col justify-center py-4 bg-gray-900 rounded-t-lg min-h-img"
                                >
                                    <div
                                        class="flex content-between justify-between w-full my-2"
                                    >
                                        <!-- <div class="w-2/12 mx-auto my-2">
                                            <span class="inline-block text-lg font-bold text-center text-blue-300 border border-blue-300 border-solid rounded-full w-7 h-7">4</span>
                                        </div> -->
                                        <div
                                            class="mx-auto w-36 cust-text-center"
                                        >
                                            <img
                                                src="/img/osm-coin.png"
                                                alt="gem"
                                                class="mx-auto"
                                                style="max-width: 90px"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box"
                                >
                                    <h4 class="mb-1 font-bold">
                                        {{ $t("How to get more OSM Coins") }}
                                    </h4>
                                    <p class="text-xs font-extralight">
                                        {{
                                            $t(
                                                "Get more OSM Coins and earn cash rewards or certificates of proficiency"
                                            )
                                        }}
                                    </p>
                                </div>
                            </inertia-link>
                        </div>

                        <!-- <div class="w-6/12 p-2 md:w-4/12">
                            <div class="bg-white rounded-lg shadow-md">
                                <a href="https://eventiosm.it/" target="blank">
                                    <div class="flex flex-col justify-center bg-gray-900 rounded-t-lg min-h-img py-7 event-bkg">
                                        
                                    </div>
                                    <div class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box">
                                        <h4 class="mb-1 font-bold">{{ $t('OSM Events') }}</h4>
                                        <p class="text-xs font-extralight">
                                            {{ $t('Find the OSM event closest to you') }}
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div> -->

                        <!--Shop-->
                        <div class="w-6/12 p-2 md:w-4/12">
                            <div class="bg-white rounded-lg shadow-md">
                                <div class="bg-white rounded-lg shadow-md">
                                    <div
                                        class="flex flex-col justify-center bg-gray-900 rounded-t-lg min-h-img"
                                    >
                                        <div
                                            class="flex content-between justify-between w-full"
                                        >
                                            <div
                                                class="w-full mx-auto cust-text-center"
                                            >
                                                <img
                                                    src="/img/iosm-logo.png"
                                                    alt="gem"
                                                    class="w-full"
                                                    style="
                                                        max-width: 100px;
                                                        margin: 0 auto;
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="
                                            device == 'ios' ||
                                            device == 'android'
                                        "
                                        class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box"
                                    >
                                        <h4 class="mb-1 font-bold">
                                            {{ $t("Download iOSM App") }}
                                        </h4>
                                        <p class="text-xs font-extralight">
                                            {{
                                                $t(
                                                    "Training has never been so easy, wherever you are and in a fun and interactive way"
                                                )
                                            }}
                                        </p>
                                        <ul class="flex mt-2">
                                            <li
                                                v-if="device == 'ios'"
                                                class="pr-3"
                                            >
                                                <a
                                                    href="https://apps.apple.com/it/app/iosm/id1502970051"
                                                    target="blank"
                                                >
                                                    <img
                                                        src="/img/icons/apple-logo.png"
                                                        alt="app iOSM"
                                                        class="w-6"
                                                    />
                                                </a>
                                            </li>
                                            <li v-if="device == 'android'">
                                                <a
                                                    href="https://play.google.com/store/apps/details?id=com.dieffetech.osmitalia&hl=it&gl=US&pli=1"
                                                    target="blank"
                                                >
                                                    <img
                                                        src="/img/icons/android-logo.png"
                                                        alt="app Android"
                                                        class="w-6 mt-1"
                                                    />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-else>
                                        <a
                                            href="https://engageeditore.com/products/iosm-app-accesso-completo?_pos=1&_sid=dcd553f78&_ss=r"
                                        >
                                            <div
                                                class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box"
                                            >
                                                <h4 class="mb-1 font-bold">
                                                    {{
                                                        $t("Download iOSM App")
                                                    }}
                                                </h4>
                                                <p
                                                    class="text-xs font-extralight"
                                                >
                                                    {{
                                                        $t(
                                                            "Training has never been so easy, wherever you are and in a fun and interactive way"
                                                        )
                                                    }}
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="orders > 0" class="w-6/12 p-2 md:w-4/12">
                            <inertia-link
                                :href="route('shop.show')"
                                class="pb-2 bg-white rounded-lg shadow-md"
                            >
                                <div class="bg-white rounded-lg shadow-md">
                                    <div
                                        class="flex flex-col justify-center bg-gray-900 rounded-t-lg min-h-img"
                                    >
                                        <div
                                            class="flex content-between justify-between w-full"
                                        >
                                            <div
                                                class="w-full mx-auto cust-text-center"
                                            >
                                                <img
                                                    src="/img/icons-order.png"
                                                    alt="gem"
                                                    class="w-full"
                                                    style="
                                                        max-width: 100px;
                                                        margin: 0 auto;
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box"
                                    >
                                        <h4 class="mb-1 font-bold">
                                            {{ $t("Orders") }}
                                        </h4>
                                        <p class="text-xs font-extralight">
                                            {{
                                                $t(
                                                    "Here are the products purchased"
                                                )
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </inertia-link>
                        </div>

                        <div class="w-6/12 p-2 md:w-4/12">
                            <inertia-link
                                :href="route('shop')"
                                class="pb-2 bg-white rounded-lg shadow-md"
                            >
                                <div
                                    class="flex flex-col justify-center py-4 bg-gray-900 rounded-t-lg min-h-img"
                                >
                                    <div
                                        class="flex content-between justify-between w-full my-2"
                                    >
                                        <div
                                            class="mx-auto w-36 cust-text-center"
                                        >
                                            <img
                                                src="/img/osm-coin.png"
                                                alt="gem"
                                                class="mx-auto"
                                                style="max-width: 90px"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="w-full px-3 py-4 bg-white rounded-b-lg min-h-box"
                                >
                                    <h4 class="mb-1 font-bold">
                                        {{ $t("Buy Items using OSM Coins") }}
                                    </h4>
                                    <p class="text-xs font-extralight">
                                        {{
                                            $t(
                                                "Use your OSM Coin and buy digital items"
                                            )
                                        }}
                                    </p>
                                </div>
                            </inertia-link>
                        </div>
                    </div>
                </div>
                <!-- how to -->
                <div class="w-full px-4 py-8 text-white bg-gray-900">
                    <div class="mx-auto md:max-w-screen-xl">
                        <h1 class="mb-4 text-2xl text-white">
                            {{ $t("How to get more") }}
                            <span class="text-pink-600">{{
                                $t(" OSM Coins")
                            }}</span>
                        </h1>
                        <div>
                            <HowToSlider></HowToSlider>
                        </div>
                    </div>
                </div>
                <!-- curriculums -->
                <div class="w-full px-4 py-8 text-white bg-gray-800">
                    <div class="mx-auto md:max-w-screen-xl">
                        <h1 class="mb-4 text-2xl text-white">
                            {{ $t("Nuovi") }}
                            <span class="text-pink-600">{{
                                $t("Programmi")
                            }}</span>
                        </h1>
                        <div>
                            <CurriculumSlider
                                :curriculums="curriculums"
                            ></CurriculumSlider>
                        </div>
                    </div>
                </div>
                <!-- osm events -->
                <!-- <div class="w-full px-4 py-8 mb-8 text-white bg-gray-900">
                    <div class="mx-auto md:max-w-screen-xl">
                        <h1 class="mb-4 text-2xl text-white">
                            <span class="text-pink-600">{{
                                $t("Eventi")
                            }}</span>
                        </h1>
                        <div>
                            <EventSlider :events="events"></EventSlider>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </customer-layout>
</template>

<script>
import BottomBar from "@/Layouts/BottomBar";
import { Slider, SliderItem } from "vue-easy-slider";
import SelectLocaleVue from "../Components/SelectLocale.vue";
import EventSlider from "../Components/Sliders/EventSlider.vue";
import CurriculumSlider from "../Components/Sliders/CurriculumSlider.vue";
import SlideSlider from "../Components/Sliders/SlideSlider.vue";
import HowToSlider from "../Components/Sliders/HowToSlider.vue";
import CustomerLayout from "../Layouts/CustomerLayout.vue";
import UpcomingEventSlider from "../Components/Sliders/UpcomingEventSlider.vue";
import { Carousel, Slide } from "vue-carousel";

export default {
    props: [
        
        "user",
        "slides",
        "survey",
        "current",
        "diamonds",

        "userDownload",
        "curriculums",
        "orders",
    ],
    components: {
        BottomBar,
        Slider,
        SliderItem,
        SelectLocaleVue,
        EventSlider,
        CurriculumSlider,
        SlideSlider,
        HowToSlider,
        CustomerLayout,
        UpcomingEventSlider,
        Carousel,
        Slide,
    },
    data() {
        return {
            list: [
                { backgroundColor: "#3f51b5", width: "100%", height: "100%" },
                { backgroundColor: "#eee", width: "100%", height: "100%" },
                { backgroundColor: "#f44336", width: "100%", height: "100%" },
            ],
            device: "",
        };
    },
    created() {
        this.getMobileOS();
    },
    methods: {
        checkDevice() {
            const ua = navigator.userAgent;
            if (/android/i.test(ua)) {
                return "android";
            } else if (/windows/i.test(ua)) {
                return "windows";
            } else if (/Macintosh/i.test(ua)) {
                return "macbook";
            } else if (/linux/i.test(ua)) {
                return "linux";
            } else if (/iPad|iPhone|iPod/i.test(ua)) {
                return "ios";
            }
            return "other";
        },
        getMobileOS() {
            this.device = this.checkDevice();
        },
    },
};
</script>
<style scoped>
.cust-text-center {
    text-align: -webkit-center;
}
.min-h-img {
    min-height: 9rem;
}
.min-h-box {
    min-height: 11rem;
}
.cust-background-how {
    background-color: #49467d;
}
.slide-content {
    position: relative;
    color: white;
    text-align: center;
}

.text-transparent {
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
}

.vue-carousel-dot {
    background-color: gray; /* Default dot color */
}

.vue-carousel-dot-active {
    background-color: yellow !important; /* Active dot color */
}
</style>
